module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2eiRD"))).then(() => parcelRequire('hEqeo'));